import { createTheme } from "@material-ui/core/styles";

import "fontsource-roboto";

const theme = createTheme({});

export default theme;
